module.exports = "fragment StoreManagerDetails on EmployeeType{__typename id fullName phone1 phone2 email}"